import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiBriefcase, FiRefreshCw } from 'react-icons/fi';
import { Button } from './ui/button';

export const EssentialPlanRequiredCard = ({
  module = 'carteiras',
  titleBadge = 'RECURSO EXCLUSIVO ESSENCIAL',
  description,
  buttonText = 'Fazer Upgrade para o Essencial',
  onUpgrade,
}) => {
  const navigate = useNavigate();

  const isConciliacao = module === 'conciliacao' || module === 'conciliação';

  const defaultDescription = isConciliacao
    ? 'Faça o upgrade para a Assinatura Essencial para realizar a conciliação bancária automática com arquivos OFX/CSV e conferência de lançamentos.'
    : 'Faça o upgrade para a Assinatura Essencial para vincular registros a carteiras, bancos vinculados e plano de contas.';

  const handleUpgradeClick = () => {
    if (onUpgrade) {
      onUpgrade();
    } else {
      navigate('/assinatura');
    }
  };

  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-140px)] p-4 sm:p-6">
      <div className="p-8 sm:p-10 bg-emerald-50/80 dark:bg-emerald-950/30 border border-emerald-500/30 dark:border-emerald-500/40 rounded-2xl text-center space-y-4 max-w-lg w-full shadow-sm animate-in fade-in duration-200">
        <div className="w-12 h-12 rounded-full bg-emerald-500/20 text-emerald-600 dark:text-emerald-400 flex items-center justify-center mx-auto">
          {isConciliacao ? (
            <FiRefreshCw size={22} />
          ) : (
            <FiBriefcase size={22} />
          )}
        </div>

        <div>
          <span className="inline-block px-3 py-0.5 rounded-full text-[10px] font-black uppercase tracking-wider bg-emerald-500/15 text-emerald-700 dark:text-emerald-400 border border-emerald-500/30">
            {titleBadge}
          </span>
        </div>

        <p className="text-sm sm:text-base font-semibold text-emerald-900 dark:text-emerald-200 max-w-md mx-auto leading-relaxed">
          {description || defaultDescription}
        </p>

        <div className="pt-1">
          <Button
            type="button"
            size="sm"
            onClick={handleUpgradeClick}
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs sm:text-sm px-6 py-2.5 shadow-md shadow-emerald-600/20 rounded-xl transition-all hover:scale-[1.02] active:scale-[0.98]"
          >
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EssentialPlanRequiredCard;
